import { useState } from 'react';

export interface RippleData {
  x: number;
  y: number;
  id: number;
  size?: number;
}

export type RippleMap<T extends string | number = string | number> = {[key in T]?: RippleData[]};

export const useRipple = <T extends string | number = string>() => {
  const [ripples, setRipples] = useState<RippleMap<T>>({});

  const createRipple = (event: React.MouseEvent, id: T, callback?: () => void, delay: number = 150) => {
    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const rippleId = Date.now();

    // Kapsayıcının boyutlarını al
    const width = rect.width;
    const height = rect.height;
    
    // Tıklanan noktadan kapsayıcının köşelerine olan mesafeleri hesapla
    const distanceToTopLeft = Math.sqrt(x * x + y * y);
    const distanceToTopRight = Math.sqrt((width - x) * (width - x) + y * y);
    const distanceToBottomLeft = Math.sqrt(x * x + (height - y) * (height - y));
    const distanceToBottomRight = Math.sqrt((width - x) * (width - x) + (height - y) * (height - y));
    
    // En uzak köşeye olan mesafeyi bul (ripple'ın tam boyutu)
    const maxDistance = Math.max(
      distanceToTopLeft,
      distanceToTopRight,
      distanceToBottomLeft,
      distanceToBottomRight
    );

    const newRipple: RippleData = { 
      x, 
      y, 
      id: rippleId,
      size: Math.max(maxDistance * 2, Math.max(width, height) * 1.5) // En az kapsayıcının 1.5 katı
    };

    setRipples(prev => ({
      ...prev,
      [id]: [...(prev[id] || []), newRipple]
    }));

    // Callback'i delay'den sonra çalıştır
    if (callback) {
      setTimeout(callback, delay);
    }

    // Ripple'ı temizle
    setTimeout(() => {
      setRipples(prev => ({
        ...prev,
        [id]: (prev[id] || []).filter(ripple => ripple.id !== rippleId)
      }));
    }, 600);
  };

  return { ripples, createRipple };
};
